import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../common/constants.tsx';
import type { Options, StatusUpdateHandler } from './types.tsx';
import { useDeleteRecord } from './use-delete-record/index.tsx';
import { useHandleStatusUpdate } from './use-handle-status-update/index.tsx';

const DEFAULT_OPTIONS: Options = {
	isHideDoneEnabled: false,
};

export function useHideDoneItems(
	itemsConnectionId: string,
	recordId: string,
	options: Options = DEFAULT_OPTIONS,
) {
	const updater = useDeleteRecord(itemsConnectionId, recordId);
	const handler = useHandleStatusUpdate(updater, options);

	return useCallback<StatusUpdateHandler>(
		(issueKey, fieldName, field) => {
			try {
				handler(issueKey, fieldName, field);
			} catch (error: unknown) {
				if (error instanceof Error) {
					fireErrorAnalytics({
						meta: {
							id: 'issue-table-hide-done-status-update',
							packageName: PACKAGE_NAME,
							teamName: TEAM_NAME,
						},
						error,
					});
				}
			}
		},
		[handler],
	);
}
